import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: auto;
  padding: ${theme.spacing['2xl']};
`;
